<script setup lang="ts">
import { LibraryObjectsByType } from '@/library/library_types'
import LibraryFolderContentSection from '@/library/LibraryFolderContentSection.vue'
import { useVisibilityStore } from '@/visibility/visibility.store'
import { storeToRefs } from 'pinia'

withDefaults(
  defineProps<{
    contentObjectsByType: LibraryObjectsByType
    headingLevel?: number
  }>(),
  { headingLevel: 2 }
)
const visibilityStore = useVisibilityStore()
const { iodVisibility } = storeToRefs(visibilityStore)
</script>
<template>
  <LibraryFolderContentSection
    v-if="contentObjectsByType.impact_of_disabilities?.length && iodVisibility"
    :contentObjects="contentObjectsByType.impact_of_disabilities"
    contentTypeTitle="Impact of Disability"
    :removableContents="false"
    :saved="true"
    :headingLevel="headingLevel"
  />
  <LibraryFolderContentSection
    v-if="contentObjectsByType.presentlevels?.length"
    :contentObjects="contentObjectsByType.presentlevels"
    contentTypeTitle="Present Levels"
    :removableContents="false"
    :saved="true"
    :headingLevel="headingLevel"
  />
  <LibraryFolderContentSection
    v-if="contentObjectsByType.goals?.length"
    :contentObjects="contentObjectsByType.goals"
    contentTypeTitle="Goals"
    :removableContents="false"
    :saved="true"
    :headingLevel="headingLevel"
  />
  <LibraryFolderContentSection
    v-if="contentObjectsByType.strategies?.length"
    :contentObjects="contentObjectsByType.strategies"
    contentTypeTitle="Strategies"
    :numberOfItems="2"
    :removableContents="false"
    :saved="true"
    :headingLevel="headingLevel"
  />
  <LibraryFolderContentSection
    v-if="contentObjectsByType.resources?.length"
    contentTypeTitle="Resources"
    :contentObjects="contentObjectsByType.resources"
    :gridView="false"
    :removableContents="false"
    :saved="true"
    :headingLevel="headingLevel"
  />
</template>
